export default __webpack_public_path__ + "static/media/ricevuta_acquisto_smartphonecash_-01.2f694884.svg";